/**
 * @voltxampere/ui — 7905 -5V fixed linear regulator (Sprint 40-1)
 *
 * Negative-rail counterpart to 7805. TO-220 linear regulator, -5 V
 * output for ±5 V dual supplies (op-amp / data-converter rails).
 * V_in must be ≤ -7 V. Reuses the dc-source SVG; canonical
 * `voltage-source` engine type with negative `voltage` param.
 *
 * Reference: Fairchild MC7905. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulator7905 = {
    id: "7905",
    nameTr: "7905 (-5V Sabit, TO-220)",
    nameEn: "7905 (-5V Fixed, TO-220)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "7905",
    schemaType: "voltage-source",
    defaultParams: { voltage: -5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-7905.js.map